/**
 * Barra lateral de navegación (Sidebar) para el Panel de Laboratorio.
 * Gestiona los enlaces a las herramientas de registro de pacientes, gestión de casos,
 * consulta de reportes anonimizados y opciones de cuenta para el personal de laboratorio.
 */

import { useNavigate, useLocation } from "react-router-dom";

const LabSidebar = ({ currentView, setView, isOpen, toggle }) => {
    const navigate = useNavigate();
    const location = useLocation();

    /**
     * Finaliza la sesión del usuario y redirige al login.
     */
    const handleLogout = () => {
        localStorage.clear();
        navigate("/Login");
    };

    /**
     * Determina si un enlace de la barra lateral debe marcarse como activo.
     * Soporta tanto vistas internas del dashboard (currentView) como rutas reales.
     */
    const isActive = (viewOrPath) => {
        if (viewOrPath.startsWith("/")) {
            return location.pathname === viewOrPath;
        }
        return currentView === viewOrPath;
    };

    return (
        <aside className={`admin-sidebar ${isOpen ? 'mobile-open' : ''}`} style={{ background: 'linear-gradient(180deg, #0b3b5a 0%, #062133 100%)' }}>
            {/* Botón de cierre para dispositivos móviles */}
            <button className="mobile-nav-toggle position-absolute top-0 end-0 m-2 d-md-none text-white" onClick={toggle}>
                <i className="bi bi-x-lg"></i>
            </button>

            <div className="sidebar-brand">
                <i className="bi bi-person-workspace"></i>
                <span>Panel de Lab</span>
            </div>

            <nav className="sidebar-nav">
                {/* Sección de Inicio */}
                <button
                    className={`sidebar-link ${isActive("home") ? "active" : ""}`}
                    onClick={() => setView("home")}
                >
                    <i className="bi bi-grid-fill"></i>
                    <span>Inicio Dashboard</span>
                </button>

                <div className="sidebar-label mt-3 mb-2 px-3 text-uppercase small text-white-50" style={{ fontSize: '0.75rem' }}>Gestión de Registros</div>

                <button
                    className={`sidebar-link ${isActive("registrarPaciente") ? "active" : ""}`}
                    onClick={() => setView("registrarPaciente")}
                >
                    <i className="bi bi-person-plus-fill"></i>
                    <span>Registrar Paciente</span>
                </button>
                <button
                    className={`sidebar-link ${isActive("buscarPaciente") || isActive("registrarCaso") ? "active" : ""}`}
                    onClick={() => setView("buscarPaciente")}
                >
                    <i className="bi bi-clipboard2-plus-fill"></i>
                    <span>Nuevo Caso Clínico</span>
                </button>

                <div className="sidebar-label mt-3 mb-2 px-3 text-uppercase small text-white-50" style={{ fontSize: '0.75rem' }}>Consultas y Reportes</div>

                <button
                    className={`sidebar-link ${isActive("misPacientes") ? "active" : ""}`}
                    onClick={() => setView("misPacientes")}
                >
                    <i className="bi bi-people-fill"></i>
                    <span>Censo de Pacientes</span>
                </button>
                <button
                    className={`sidebar-link ${isActive("misCasos") ? "active" : ""}`}
                    onClick={() => setView("misCasos")}
                >
                    <i className="bi bi-clipboard-data-fill"></i>
                    <span>Historial de Casos</span>
                </button>
                <button
                    className={`sidebar-link ${isActive("reporteAnonimizado") ? "active" : ""}`}
                    onClick={() => setView("reporteAnonimizado")}
                >
                    <i className="bi bi-shield-lock-fill"></i>
                    <span>Reportes Anonimizados</span>
                </button>

            </nav>

           
                <button
                    className={`sidebar-link ${isActive("/CambiarPassword") ? "active" : ""}`}
                    onClick={() => navigate("/CambiarPassword")}
                >
                    <i className="bi bi-shield-lock-fill text-warning"></i>
                    <span>Seguridad y Clave</span>
                </button>
                <button className="btn btn-danger btn-sm border-secondary" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right me-1"></i>
                    Cerrar Sesión
                </button>
            
        </aside>
    );
};

export default LabSidebar;
